import React from "react";

export const minMax = (number, max = Number.POSITIVE_INFINITY, min = 0) =>
  Math.min(max, Math.max(min, number));

export const htmlToText = html => {
  if (!html) return null;

  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  return tmp.textContent || tmp.innerText || "";
};

export const highlightMatch = (text, searchTerm) => {
  if (!searchTerm) return text;

  const regex = new RegExp(`(${searchTerm})`, "gi");

  return text.split(regex).map((part, index) =>
    part?.toLowerCase() === searchTerm.toLowerCase() ? (
      <span className="neeto-molecules-finder-matched-tag" key={index}>
        {part}
      </span>
    ) : (
      part
    )
  );
};

export const filterAndHighlightContent = (bodyContent, searchTerm) => {
  if (!searchTerm) return bodyContent;

  if (!bodyContent) return null;

  return bodyContent
    .split(/(.{1,130}(?:\s|$))/g)
    .filter(line => line.trim())
    .filter(line => line.toLowerCase().includes(searchTerm.toLowerCase()))
    .map((line, index) => (
      <React.Fragment key={index}>
        {highlightMatch(line, searchTerm)}
        <br />
      </React.Fragment>
    ));
};

export const flattenData = data => {
  if (!data) return [];

  if (Array.isArray(data)) return data;

  const result = [];
  Object.keys(data).forEach(key => {
    data[key].forEach(item => {
      result.push({ ...item, category: key });
    });
  });

  return result;
};

export const createStylePalette = values => {
  const assignedStyles = {};
  let styleIndex = 0;

  return key => {
    if (assignedStyles[key]) return assignedStyles[key];
    const style = values[styleIndex];
    styleIndex = (styleIndex + 1) % values.length;
    assignedStyles[key] = style;

    return style;
  };
};
